import { message, Modal } from 'antd';
import { globalStore, load, mock } from '@/common'   
import { registerMocks } from './mock';
import { Project, ProjectAddEditParam, projectPageModel } from './model';
import { projectApi } from './ProjectApi';
import { DatePickerProps } from 'antd/es';
import { formatTimeStr } from 'antd/lib/statistic/utils';
import { DateUtil } from '@/utils/DateUtil';
const initialize = async () => {
    if(mock){
        registerMocks();
    }
    if(!globalStore.currentUser){
        load();
    } 
    await projectPageModel.initialize();
}   

const addProject = async (project: ProjectAddEditParam): Promise<number> => {
    const result = await projectApi.addOrEditProject(project);
    if (result >= 0) {
        message.success('创建成功');
        await projectPageModel.reloadProjects();
    }
    return result;
};

const updateProject = async (project: ProjectAddEditParam): Promise<number> => {
    const result = await projectApi.addOrEditProject(project);
    if (result >= 0) {
        message.success('更新成功');
        await projectPageModel.reloadProjects();
    }
    return result;
};

const deleteProject =  (id:string | number) => {

    Modal.confirm({
        title: '操作确认',
        content: '是否确认删除该项目',
        onOk: async () => {
            try {
              const result = await projectApi.deleteProject(id);
              if (result) {
                const keep = (project: Project) =>
                  String(project.id) !== String(id);
                projectPageModel.projects =
                  projectPageModel.projects.filter(keep);
                projectPageModel.filteredList =
                  projectPageModel.filteredList.filter(keep);
                message.success('删除成功');
              }
            } catch (e) {
              console.error(e);
              message.error('删除失败');
            }
        }
      }) 
 }


const changeStatus = async (id:string | number, status:number)=>{
    const param : ProjectAddEditParam = new ProjectAddEditParam();
    param.id = id;
    param.status = status;

    let targetProject:Project = null;
    projectPageModel.filteredList.forEach((project:Project)=>{
        if(project.id == id){
            targetProject= project; 
        }
    })
    if(!targetProject){
        message.warning("找不到对应的项目！")
        return;
    }

    let oldStatus = targetProject.status;
    targetProject.status = status;
    projectApi.addOrEditProject(param).then((result)=>{
        if(result < 0){
            //失败了，退回之前的状态
            targetProject.status = oldStatus;
        }
    });
}


const changeMonthRange: DatePickerProps['onChange'] = async (date, dateString) => { 
     if(!date){
        projectPageModel.monthFilterMode = 'all';
        projectPageModel.currentMonth = undefined;
        await projectPageModel.reloadProjects();
        return;
     }
     projectPageModel.monthFilterMode = 'month';
     projectPageModel.currentMonth =  DateUtil.getDateFromDateString(dateString);
     await projectPageModel.reloadProjects();
};


export const ctrl = { 
    initialize,
    changeStatus,
    addProject,
    updateProject,
    deleteProject,
    changeMonthRange
}